<template>
  <el-header class="header">
    <div class="container header-content">
      <div class="logo">
        <router-link to="/" class="logo-link">
          <img src="/xy_logo.jpg" alt="向远物流" class="logo-image" />
        </router-link>
      </div>
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMobileMenu">
        <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
      </div>
      <!-- 桌面端导航菜单 -->
      <el-menu
        :default-active="activeIndex"
        class="nav-menu desktop-menu"
        mode="horizontal"
        router
        @select="handleSelect"
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/services">服务项目</el-menu-item>
        <el-menu-item index="/process">运车流程</el-menu-item>
        <el-menu-item index="/cases">运车案例</el-menu-item>
        <el-menu-item index="/news">新闻资讯</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
        <el-menu-item index="/contact">联系我们</el-menu-item>
      </el-menu>
      <!-- 移动端导航菜单 -->
      <transition name="slide-down">
        <div class="mobile-menu" v-show="mobileMenuOpen">
          <el-menu
            :default-active="activeIndex"
            class="mobile-nav-menu"
            router
            @select="handleMobileSelect"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/services">服务项目</el-menu-item>
            <el-menu-item index="/process">运车流程</el-menu-item>
            <el-menu-item index="/cases">运车案例</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
            <el-menu-item index="/contact">联系我们</el-menu-item>
          </el-menu>
          <div class="mobile-contact">
            <div class="phone">
              <i class="el-icon-phone"></i>
              <a :href="`tel:${contactPhone}`">{{ contactPhone }}</a>
            </div>
          </div>
        </div>
      </transition>
      <!-- 桌面端联系方式 -->
      <div class="contact-info desktop-contact">
        <div class="phone">
          <i class="el-icon-phone"></i>
          <a :href="`tel:${contactPhone}`">{{ contactPhone }}</a>
        </div>
      </div>
    </div>
  </el-header>
</template>

<script>
import { getContact } from '../api'

export default {
  name: 'Header',
  data() {
    return {
      activeIndex: '/',
      contactPhone: '400-629-6665',
      mobileMenuOpen: false
    }
  },
  created() {
    // 初始化时设置当前路由
    this.activeIndex = this.$route.path
  },
  async mounted() {
    try {
      const res = await getContact()
      if (res.data && res.data.phone) {
        this.contactPhone = res.data.phone
      }
    } catch (error) {
      console.error('加载联系方式失败', error)
    }
  },
  watch: {
    $route(to) {
      // 路由变化时更新选中项
      this.activeIndex = to.path
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    handleMobileSelect(key) {
      this.activeIndex = key
      this.mobileMenuOpen = false
    }
  }
}
</script>

<style scoped>
.header {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 0;
  height: 80px !important;
  line-height: 80px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  position: relative;
}

.logo-link {
  text-decoration: none;
  color: #333;
  display: flex;
  align-items: center;
  height: 100%;
}

.logo-image {
  height: 60px;
  width: auto;
  max-width: 200px;
  object-fit: contain;
}

.nav-menu {
  flex: 1;
  border-bottom: none;
  margin: 0 40px;
}

.desktop-menu {
  display: flex;
}

.mobile-menu-btn {
  display: none;
  font-size: 24px;
  color: #409EFF;
  cursor: pointer;
  padding: 0 10px;
}

.contact-info {
  display: flex;
  align-items: center;
}

.phone {
  display: flex;
  align-items: center;
  color: #409EFF;
  font-size: 18px;
  font-weight: bold;
}

.phone i {
  margin-right: 8px;
  font-size: 20px;
}

.phone a {
  color: #409EFF;
  text-decoration: none;
}

/* 移动端菜单 */
.mobile-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
}

.mobile-nav-menu {
  border: none;
}

.mobile-nav-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-contact {
  padding: 15px 20px;
  border-top: 1px solid #f0f0f0;
  background: #f5f7fa;
}

.mobile-contact .phone {
  font-size: 16px;
  justify-content: center;
}

/* 动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .header {
    height: 60px !important;
    line-height: 60px;
  }

  .logo-image {
    height: 45px;
    max-width: 150px;
  }

  .desktop-menu,
  .desktop-contact {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-menu {
    display: block;
  }

  .header-content {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .logo-image {
    height: 40px;
    max-width: 120px;
  }
}
</style>

